import axios from "axios";
import store from '../store/authentication'
import route from '../router/index';

export default class ApiService {
    config = {};

    constructor(baseURL, store, headers = null) {

        if (typeof baseURL !== "string" || baseURL.trim() == "")
            throw "api service base URL Error";

        this.config = { baseURL, headers }
    }

    Get(url, config = null) {
        let request = this.config;
        if (config) {
            request = Object.assign(this.config, config);
        }
        const result = axios.get(url, request).catch((error) => {
            if (error) {
                if (error.response.status == 401) {
                    store.state.isAuthenticated = false;
                    store.state.menuItemStatus = false;
                    localStorage.clear();
                    route.push('/login')
                }
                throw new Error(`Unauthorized Api ${error}`);
            }
        });


        return result;
    }

    Post(url, data, config = null) {
        let request = this.config;

        if (config) {
            request = Object.assign(this.config, config);
        }

        const result = axios.post(url, data, request).catch((error) => {
            if (error) {
                if (error.response.status == 401) {
                    store.state.menuItemStatus = false;
                    store.state.isAuthenticated = false;
                    localStorage.clear();
                    route.push('/login')
                }
                throw new Error(`Unauthorized Api ${error}`);
            }
        });

        return result;
    }

    Put(url, data, config = null) {
        let request = this.config;

        const result = axios.put(url, data, request).catch((error) => {
            if (error) {
                if (error.response.status == 401) {
                    store.state.isAuthenticated = false;
                    store.state.menuItemStatus = false;
                    localStorage.clear();
                    route.push('/login')

                }
                throw new Error(`Unauthorized Api ${error}`);
            }
        });

        return result;
    }

    Delete(url, config = null) {
        let request = this.config;

        if (config) {
            request = Object.assign(this.config, config);
        }

        const result = axios.delete(url, request).catch((error) => {
            if (error) {
                if (error.response.status == 401) {
                    store.state.isAuthenticated = false;
                    store.state.menuItemStatus = false;
                    localStorage.clear();
                    route.push('/login')

                }
                throw new Error(`Unauthorized Api ${error}`);
            }
        });

        return result;
    }
}


//TODO: Usage 1
//import ApiService from "@/common/ApiService";
//const api = new ApiService("http://localhost:8080/api/v1/"/*, headers object*/);
//api.Get("home/items/1");

//TODO: Usage 1
//import ApiService from "@/common/ApiService";
//import urlConfig from "@/assets/urlConfig"
//const api = new ApiService(urlConfig.tourBaseAddress/*, headers object*/);
//api.Get("home/items/1");